import { all } from "redux-saga/effects";
import LoginAndRegisterWatcherSaga from "./LoginAndRegister/LoginAndRegisterWatcherSaga";
import ServiceWatcherSaga from "./Service/ServiceWatcherSaga";

export function* webportalAppRootSaga() {
    yield all([
        LoginAndRegisterWatcherSaga(),
        ServiceWatcherSaga()
    ])
}